export function ExcludeFromCompress(fieldID) {
  var excludeField = false;
  switch (fieldID) {
    case "Name":
    case "PersonID":
    case "Photo":
    case "isAssistant":
      excludeField = true;
      break;
  }

  if (!excludeField) {
    var lowerField = fieldID.toLowerCase();
    excludeField = lowerField.indexOf("email") != -1;
  }

  return excludeField;
}
